(function() {
  // ===== Filter pills — sliding orange indicator with spring animation =====
  const bar = document.querySelector('.cc-vid-filters');
  if (!bar) return;
  const indicator = bar.querySelector('.cc-pill-indicator');
  const buttons = Array.from(bar.querySelectorAll('button[data-filter]'));
  const sections = Array.from(document.querySelectorAll('.cc-vid-section[data-cat], .cc-reviews-section[data-cat]'));

  // Map filter -> array of sections
  function sectionsFor(filter) {
    return sections.filter(s => s.dataset.cat === filter);
  }

  // Position the orange pill behind the active button
  function positionIndicator(activeBtn, animate) {
    if (!indicator || !activeBtn) return;
    const barRect = bar.getBoundingClientRect();
    const btnRect = activeBtn.getBoundingClientRect();
    const x = btnRect.left - barRect.left;
    const w = btnRect.width;
    if (!animate) {
      const prev = indicator.style.transition;
      indicator.style.transition = 'none';
      indicator.style.width = w + 'px';
      indicator.style.transform = 'translateX(' + x + 'px) scaleX(1)';
      // force reflow then restore transition
      void indicator.offsetWidth;
      indicator.style.transition = prev;
    } else {
      indicator.style.width = w + 'px';
      indicator.style.transform = 'translateX(' + x + 'px) scaleX(1)';
    }
  }

  let currentFilter = 'videos';
  let currentIndex = buttons.findIndex(b => b.classList.contains('cc-is-active'));
  if (currentIndex < 0) currentIndex = 0;

  function setFilter(filter, clickedBtn) {
    const newIndex = buttons.indexOf(clickedBtn);
    const direction = newIndex > currentIndex ? 'right' : 'left'; // moving right means new content slides in from right

    buttons.forEach(b => b.classList.toggle('cc-is-active', b === clickedBtn));
    positionIndicator(clickedBtn, true);

    // Animate sections out, then swap, then animate in
    const visible = sections.filter(s => !s.hidden);
    const outClass = direction === 'right' ? 'cc-anim-out-left' : 'cc-anim-out-right';
    const inClass  = direction === 'right' ? 'cc-anim-in-left'  : 'cc-anim-in-right';

    visible.forEach(s => s.classList.add(outClass));

    setTimeout(() => {
      sections.forEach(s => {
        s.hidden = true;
        s.classList.remove('cc-anim-out-left', 'cc-anim-out-right', 'cc-anim-in-left', 'cc-anim-in-right');
      });
      const next = sectionsFor(filter);
      next.forEach(s => {
        s.hidden = false;
        s.classList.add(inClass);
        // strip in-class after animation
        setTimeout(() => s.classList.remove(inClass), 600);
      });
      // re-run stagger for newly visible cards
      document.querySelectorAll('[data-stagger]').forEach(grid => {
        if (grid.closest('[data-cat]') && grid.closest('[data-cat]').hidden) return;
        Array.from(grid.children).forEach((c, i) => {
          c.style.animation = 'none';
          // force reflow
          void c.offsetWidth;
          c.style.animation = '';
          c.style.animationDelay = (i * 40) + 'ms';
        });
      });
    }, 200);

    currentIndex = newIndex;
    currentFilter = filter;
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;
      if (filter === currentFilter) return;
      setFilter(filter, btn);
    });
  });

  // Initial positioning (no animation on load)
  function init() {
    const active = buttons[currentIndex] || buttons[0];
    positionIndicator(active, false);
    // make sure correct sections are showing on load
    sections.forEach(s => { s.hidden = s.dataset.cat !== currentFilter; });
  }

  // Wait for fonts to settle so widths are accurate
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  } else {
    init();
  }
  // Re-init in case of layout shifts
  window.addEventListener('load', () => positionIndicator(buttons[currentIndex], false));
  window.addEventListener('resize', () => positionIndicator(buttons[currentIndex], false));

  // ===== Deep-link via hash (e.g. #reviews) =====
  function applyHash() {
    const h = (location.hash || '').replace('#', '');
    if (!h) return;
    const target = buttons.find(b => b.dataset.filter === h);
    if (target && h !== currentFilter) setFilter(h, target);
  }
  window.addEventListener('hashchange', applyHash);
  applyHash();

  // ===== Click-to-play on real video cards =====
  function buildEmbed(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/);
    if (yt) {
      var ytFrame = document.createElement('iframe');
      ytFrame.src = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      ytFrame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      ytFrame.setAttribute('allowfullscreen', '');
      ytFrame.className = 'cc-vid-embed';
      return ytFrame;
    }
    var vimeo = url.match(/vimeo\.com\/(\d+)/);
    if (vimeo) {
      var vFrame = document.createElement('iframe');
      vFrame.src = 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
      vFrame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      vFrame.setAttribute('allowfullscreen', '');
      vFrame.className = 'cc-vid-embed';
      return vFrame;
    }
    var video = document.createElement('video');
    video.src = url;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.className = 'cc-vid-embed';
    return video;
  }

  document.querySelectorAll('.cc-vid-card[data-video-src]').forEach(function(card) {
    var url = card.dataset.videoSrc;
    var thumb = card.querySelector('.cc-thumb');
    if (!url || !thumb) return;
    thumb.addEventListener('click', function() {
      thumb.innerHTML = '';
      thumb.appendChild(buildEmbed(url));
    }, { once: true });
  });
})();
